import {useMutation, useQueryClient} from 'react-query';
import {PROD_API} from '../constants/api';

interface DeleteUserParams {
  userId: string;
}

interface DeleteUserResponse {
  message: string;
}

const deleteUser = async (userId: string): Promise<DeleteUserResponse> => {
  const authTokens = JSON.parse(localStorage.getItem('authTokens') as string);

  const response = await fetch(`${PROD_API}/api/users/delete/${userId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authTokens.access}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || 'Failed to delete user');
  }

  return response.json();
};

export const useDeleteUser = () => {
  const queryClient = useQueryClient();

  return useMutation((params: DeleteUserParams) => deleteUser(params.userId), {
    onSuccess: () => {
      // Invalidate and refetch users list
      queryClient.invalidateQueries('users');
    },
    onError: (error: Error) => {
      // eslint-disable-next-line no-console
      console.error('Error deleting user:', error);
    },
  });
};
